// MODIFIED
import React, { useState } from "react";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';
import LeaveIncentiveBatchTable from "./components/LeaveIncentiveBatchTable";
import LeaveIncentiveBatchAddEditModal from "./components/LeaveIncentiveBatchAddEditModal";
import { ConfirmationModal } from "../../../../common/Modal";

const LeaveIncentiveBatchModule = ({
  data,
  loading,
  years,
  createBatch,
  updateBatch,
  processBatch,
  revertBatch
}) => {
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // ADDED: Pagination State (Matching LeaveTypeModule pattern)
  const [currentPage, setCurrentPage] = useState(1);

  // Confirmation Dialog State
  const [confirmConfig, setConfirmConfig] = useState({
    open: false,
    title: "",
    msg: "",
    action: null
  });

  const handleSearch = (value) => {
    // MODIFIED: Reset to page 1 on search like LeaveTypeModule
    setCurrentPage(1);
    // Note: searchData logic would go here if implemented in the hook
  };

  const handleSave = async (form) => {
    const res = selectedItem
      ? await updateBatch(selectedItem.id, form)
      : await createBatch(form);

    if (res.success) {
      setIsModalOpen(false);
    }
  };

  const triggerConfirm = (title, msg, action) => {
    setConfirmConfig({ open: true, title, msg, action });
  };

  return (
    <div className="p-4 space-y-4 relative">
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<AddIcon />}
          name="Create Batch"
          className="bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      {/* MODIFIED: Passing currentPage and setCurrentPage to the table */}
      <LeaveIncentiveBatchTable
        data={data}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onEdit={(item) => {
          setSelectedItem(item);
          setIsModalOpen(true);
        }}
        onView={(item) => {
          // Logic for viewing employee list goes here
          console.log("Viewing batch:", item.id);
        }}
        onProcess={(item) =>
          triggerConfirm(
            "Process Batch",
            "Are you sure you want to process this batch? This will generate incentive records for the selected period.",
            () => processBatch(item.id)
          )
        }
        onRevert={(item) =>
          triggerConfirm(
            "Revert Batch",
            "Are you sure you want to revert this batch to Draft? Existing processed records will be removed.",
            () => revertBatch(item.id)
          )
        }
      />

      <LeaveIncentiveBatchAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
        years={years}
      />

      <ConfirmationModal
        visible={confirmConfig.open}
        title={confirmConfig.title}
        message={confirmConfig.msg}
        onConfirm={async () => {
          if (confirmConfig.action) {
            await confirmConfig.action();
          }
          setConfirmConfig({ ...confirmConfig, open: false });
        }}
        onClose={() => setConfirmConfig({ ...confirmConfig, open: false })}
      />
    </div>
  );
};

export default LeaveIncentiveBatchModule;